import {SxType} from "@baseTypes/sx/sxTypes";

export const sx:SxType = {
    name:{
        wordBreak: 'break-all'
    }

}